import { useEffect, useState } from "react"
import type { Branch } from "../types/branch";
import { useNavigate, useSearchParams } from "react-router-dom";
import useBranches from "../hooks/useBranches";
import ConfirmModal from "../components/modals/Confirm";
import Header from "../components/Header";
import packageJson from '../../package.json'
import * as Sentry from '@sentry/react'
import axios from 'axios';
import { detectOS } from '../utils';

const SelectBranch = () => {
  const [filterBranch, setFilterBranch] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null);
  const navigate = useNavigate();
  const { data } = useBranches();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log(` | ${packageJson.version} | ${location.pathname} | OPEN`)
    Sentry.captureMessage(` | ${packageJson.version} | OPEN`)
  }, [])

  const showModal = (branch: Branch) => {
    setOpen(true);
    setSelectedBranch(branch);
  }

  const closeModal = () => {
    setOpen(false);
    setSelectedBranch(null);
  }

  const confirmModal = () => {
    if (selectedBranch) {
      console.log(`${selectedBranch.id} | ${packageJson.version} | ${location.pathname} | SELECT`)
      Sentry.captureMessage(`${selectedBranch.id} | ${packageJson.version} | SELECT`)
      navigate(`/leader-board?id=${searchParams.get('id')}&branch_id=${selectedBranch.id}`);
    }
    setOpen(false);
  }

  return (
    <>
      <Header />
      <div className="p-5 h-auto flex flex-col overflow-y-scroll">
        <div className="flex items-center gap-6">
          <div className="text-gray-700 text-xl font-bold tracking-wider">CHOOSE THE STORE</div>
          <div className="border border-gray-300 py-0.5 rounded w-[250px] h-6">
            <input className="bg-gray-100 px-2 text-sm w-full h-full block focus:outline-0" value={filterBranch} onChange={e => setFilterBranch(e.target.value)} placeholder="Search store name" />
          </div>
        </div>
        <div className="grid grid-cols-4 gap-x-2 gap-y-6 mt-4 pb-12">
          {data?.branches.filter(v => v.name.toLowerCase().includes(filterBranch.toLocaleLowerCase())).map(store => {
            return (
              <div key={store.id} className="select-none border border-gray-400 h-[52px] bg-gray-200 rounded-lg px-3 flex flex-col justify-center gap-1 cursor-pointer" onClick={() => showModal(store)}>
                <div className="text-sm font-semibold">{store.name}</div>
                <div className="text-xs w-full truncate">{store.location}</div>
              </div>
            )})}
        </div>
        <ConfirmModal
          open={open}
          onClose={closeModal}
          onConfirm={confirmModal}
          content={
            <>
              <div className="font-bold text-xl text-gray-700">Please confirm it's your store.</div>
              <div className="font-bold text-xl text-gray-700">{`[ ${selectedBranch?.name} ]`}</div>
            </>
          }
        />
      </div>
    </>
  )
}

export default SelectBranch